/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Role_SeInputs */

const en_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Engineer`)
};

const ar_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهندس برمجيات`)
};

const bn_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ইঞ্জিনিয়ার`)
};

const de_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler`)
};

const es_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingeniero de software`)
};

const fr_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénieur logiciel`)
};

const pt_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engenheiro de software`)
};

const zh_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件工程师`)
};

const tr_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım Mühendisi`)
};

const ru_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инженер-программист`)
};

const pl_resume_role_se = /** @type {(inputs: Resume_Role_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inżynier oprogramowania`)
};

/**
* | output |
* | --- |
* | "Software Engineer" |
*
* @param {Resume_Role_SeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_role_se = /** @type {((inputs?: Resume_Role_SeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Role_SeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_role_se(inputs)
	if (locale === "bn") return bn_resume_role_se(inputs)
	if (locale === "de") return de_resume_role_se(inputs)
	if (locale === "es") return es_resume_role_se(inputs)
	if (locale === "fr") return fr_resume_role_se(inputs)
	if (locale === "pt") return pt_resume_role_se(inputs)
	if (locale === "zh") return zh_resume_role_se(inputs)
	if (locale === "tr") return tr_resume_role_se(inputs)
	if (locale === "ru") return ru_resume_role_se(inputs)
	if (locale === "pl") return pl_resume_role_se(inputs)
	return en_resume_role_se(inputs)
});